import React from 'react'
import { Button, Table } from 'react-bootstrap'
import { Edit, Trash } from 'react-feather'

const FixedDestinationList = ({ fixedDestinationData, handleEdit, handleDelete }) => {
    return (
        <>
            <Table size='sm'>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Title</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {fixedDestinationData.map((sour, index) => (
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td style={{textTransform:'capitalize'}}>{sour.title}</td>
                            <td className="text-center">
                                <div className="d-flex gap-2 align-item-center" >
                                    <Button variant='warning' size='sm' onClick={() => handleEdit(sour)} className="p-1"><Edit size={14} /></Button>
                                    {/* <Button variant='danger' size='sm' onClick={() => handleDelete(index)} className="p-1"><Trash size={14} /></Button> */}
                                </div>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    )
}

export default FixedDestinationList
